import { ISwAppLoansApi } from "../../interfaces-and-types";

type TLoansUrls = {
  [key in keyof ISwAppLoansApi]: string;
};

const rootLoansUrl = "/lender-borrower-links";

export const loansUrls: TLoansUrls = {
  getLenderBorrowerLinks: `${rootLoansUrl}`,
  getLenderBorrowerLinkByLenderCode: `${rootLoansUrl}/lender_code`,
};
